/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- all exports are ImporterLocale which is already fully typed */
export const deDE = {
    general: {
        goToPreviousStepTooltip: 'Zum vorherigen Schritt'
    },
    fileStep: {
        initialDragDropPrompt: 'CSV-Datei auf dieses Feld ziehen, oder klicken um eine Datei auszuwählen',
        activeDragDropPrompt: 'CSV-Datei auf dieses Feld ziehen...',
        nextButton: 'Spalten auswählen',
        getImportError: (message) => `Fehler beim Import: ${message}`,
        getDataFormatError: (message) => `Bitte Datenformat überprüfen: ${message}`,
        unsupportedFileFormatError: 'Dateiformat nicht unterstützt',
        goBackButton: 'Zurück',
        rawFileContentsHeading: 'Originaler Datei-Inhalt',
        previewImportHeading: 'Import-Vorschau',
        dataHasHeadersCheckbox: 'Mit Kopfzeile',
        previewLoadingStatus: 'Vorschau wird geladen...'
    },
    fieldsStep: {
        stepSubtitle: 'Spalten auswählen',
        requiredFieldsError: 'Bitte weise allen nicht optionalen Spalten einen Wert zu',
        nextButton: 'Importieren',
        dragSourceAreaCaption: 'Zu importierende Spalte',
        getDragSourcePageIndicator: (currentPage, pageCount) => `Seite ${currentPage} von ${pageCount}`,
        getDragSourceActiveStatus: (columnCode) => `Spalte ${columnCode} zuweisen`,
        nextColumnsTooltip: 'Nächste Spalten anzeigen',
        previousColumnsTooltip: 'Vorherige Spalten anzeigen',
        clearAssignmentTooltip: 'Zugewiesene Spalte entfernen',
        selectColumnTooltip: 'Spalte zum Zuweisen auswählen',
        unselectColumnTooltip: 'Spalte abwählen',
        dragTargetAreaCaption: 'Zielfelder',
        getDragTargetOptionalCaption: (field) => `${field} (optional)`,
        getDragTargetRequiredCaption: (field) => `${field} (erforderlich)`,
        dragTargetPlaceholder: 'Spalte hierher ziehen',
        getDragTargetAssignTooltip: (columnCode) => `Spalte ${columnCode} zuweisen`,
        dragTargetClearTooltip: 'Zugewiesene Spalte entfernen',
        columnCardDummyHeader: 'Nicht zugewiesenes Feld',
        getColumnCardHeader: (code) => `Spalte ${code}`
    },
    progressStep: {
        stepSubtitle: 'Importieren',
        uploadMoreButton: 'Weitere hochladen',
        finishButton: 'Abschließen',
        statusError: 'Konnte nicht importiert werden',
        statusComplete: 'Fertig',
        statusPending: 'Wird importiert...',
        processedRowsLabel: 'Verarbeitete Zeilen:'
    }
};
